<template>
  <div>
    <ul v-if="!placeholder" role="list" class="">
      <li v-for="(item, idx) in items" :key="idx" class="flex mb-2">
        <div class="flex-auto">
          <div class="flex items-baseline justify-between gap-x-4">
            <div class="text-sm leading-6 text-gray-900">{{ item[nameProp] }}</div>
            <div class="mr-4 text-sm flex-none font-semibold text-gray-900">{{ item[scoreProp] }}</div>
          </div>
          <equalizer-value class="my-1" :value="item[scoreProp]" :max="10" :height="12" :reverse="true" :color="color"></equalizer-value>
        </div>
      </li>
    </ul>
    <ul v-else role="list" class="">
      <li v-for="i in 3" :key="i" class="">
        <div class="animate-pulse my-4 space-y-2">
          <div class="h-4 bg-slate-200 rounded w-1/3"></div>
          <div class="h-4 bg-slate-200 rounded w-full"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import EqualizerValue from '@/components/Charts/EqualizerValue.vue';

  const props = defineProps({
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    nameProp: {
      type: String,
      default: 'name',
    },
    scoreProp: {
      type: String,
      default: 'score',
    },
    color: {
      type: String,
      default: '#065f46',
    },
    placeholder: {
      type: Boolean,
      default: false,
    },
  });
</script>
